import React from 'react';

import { Box } from '@material-ui/core';

import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
// import LandingAnswer from "../../Landing/Answer";
// import RegisterFormAnswer from "./components/RegisterForm";
import LandingNext from '../../Landing/Next';
import { useErrorHandling, useRegister } from '../hook';

const RegisterAnswer = () => {
  const { isLoading, isError, error, handleSubmit: onSubmit } = useRegister();
  const { open, dialog, handleClose } = useErrorHandling(
    !isLoading && isError,
    error
  );

  if (isLoading) {
    return (
      <Box display="block">
        <Loader action={'Registrando...'} />
      </Box>
    );
  }

  return (
    <>
      <SharedDialog
        open={open}
        onClose={handleClose}
        title={dialog?.title}
        content={dialog?.content}
        actions={dialog?.action}
      />
      {/* <LandingAnswer>
        <RegisterFormAnswer onSubmit={onSubmit} />
      </LandingAnswer> */}
      <LandingNext />
    </>
  );
};

RegisterAnswer.displayName = 'RegisterAnswer';
export default RegisterAnswer;
